@import "/src/variables/font_size";
@import "/src/variables/color";
@import "/src/variables/font";
@import "/src/variables/tokens";
@import "/src/variables/breakpoints";

.drawerContainer {
  max-width: 450px;
  width: 100%;
  background-color: $zv-surface--blue-95-9-v3 !important;
  // Theme Studio dialog radius (top corners); fallback = shipped.
  border-radius: $zv-dialog-radius--border-radius-10 $zv-dialog-radius--border-radius-10 0 0;
}

.puller {
  margin-top: $space-5;
  width: 45px;
  align-self: center;
  justify-self: center;
  margin-bottom: $space-25;
}

.actionBtnContainer {
  display: flex;
  flex-direction: column;
  background-color: $zv-surface--Primary-BG-Color;
  border-radius: $border-radius-sm;
  padding: $space-10 $space-20;
  gap: $space-20;
  .actionBtn {
    @media screen and (max-width: $breakpoint-mobile-max) {
      cursor: default;
    }
    cursor: pointer;
    display: flex;
    gap: $space-25;
    align-items: center;
    padding: $space-5 0;
    & h1 {
      font-size: $font-size-h17;
      font-weight: $bold;
      color: $zv-text-primary--Neutral-Darkest;
      font-family: $font-primary;
    }
    & img {
      width: 24px;
      height: auto;
    }
  }
}
